import React from "react";
import '../../style_new.css';
import ProjectSlider   from '../../components/Slider.js';


const Services = () => {
  return (
    <>
      {/* services section start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-end mb-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="border-start border-5 border-primary ps-4">
                <h6 className="text-body text-uppercase mb-2">Our Project</h6>
                <h1 className="display-6 mb-0">
                  Ongoing And Completed Projects
                </h1>
              </div>
            </div>
         
          </div>
          <div className="row g-4 justify-content-center">
            <ProjectSlider/>
          </div>
        </div>
      </div>
      {/* services section end */}
    </>
  );
};



  
export default Services;